import { GET_FILE_PATH } from "~/constants/swrKey";
import { useSwrManagement } from "~/hooks/useSwrManagement";
import { getFilePath } from "~/services/getFilePath";

const fetcher = async (s3Key: string) => {
  const path = await getFilePath(s3Key);
  return path;
};

export const useGetFilePath = (s3Key: string) => {
  const swrKey = createSWRKey(s3Key);

  const { data: path } = useSwrManagement({
    swrKey,
    fetcher: () => fetcher(s3Key),
  });

  return path;
};

const createSWRKey = (s3Key: string) => {
  return [GET_FILE_PATH, s3Key].join("|");
};
